<template>
    <div>
        <!-- Header Start -->
        <div class="row">
            <div class="col-md-5">
                <h2>Service Operation <i class="fas fa-info-circle fa-xs ml-3 mt-2" id="serviceOperation"></i></h2>
                <b-popover
                    target="serviceOperation"
                    title="Service Operation"
                    triggers="hover focus"
                    placement="right"
                    :content="tooltip.serviceOperation"
                ></b-popover>
            </div>
            <div class="col-md-7">
                <period
                    @newDateRange="newDateRange"
                ></period>
            </div>
        </div>
        <!-- Header End -->

        <!-- Unit Entry by PKB & PKB Details Start -->
        <div class="row">
            <div class="col-md-6 mt-5">
                <div class="outerBox h-100">
                    <div class="row innerBox h-100">
                        <div class="col-12">
                            <div class="row">
                                <div class="col-md-12">
                                    <h2>Unit Entry By PKB <i class="fas fa-info-circle fa-xs ml-3 mt-2" id="unitEntryByPkb"></i></h2>
                                    <b-popover
                                        target="unitEntryByPkb"
                                        title="Unit Entry By PKB"
                                        triggers="hover focus"
                                        placement="top"
                                        :content="tooltip.unitEntryByPkb"
                                    ></b-popover>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <unit-entry-by-pkb
                                v-if="data['unit-by-pkb']"
                                :data="data['unit-by-pkb']"
                            ></unit-entry-by-pkb>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6 mt-5">
                <div class="outerBox h-100">
                    <div class="row innerBox h-100">
                        <div class="col-12">
                            <div class="row">
                                <div class="col-md-6">
                                    <h2>PKB Details <i class="fas fa-info-circle fa-xs ml-3 mt-2" id="pkbDetails"></i></h2>
                                    <b-popover
                                        target="pkbDetails"
                                        title="PKB Details"
                                        triggers="hover focus"
                                        placement="top"
                                        :content="tooltip.pkbDetails"
                                    ></b-popover>
                                </div>
                                <div class="col-md-6">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="input-group">
                                              <MultiSelect
                                                v-model="filter['pkb-details'].region"
                                                class="dealerService"
                                                :options="options['pkb-details'].region"
                                                placeholder="All Wilayah Kerja"
                                              ></MultiSelect>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="input-group">
                                              <MultiSelect
                                                v-model="filter['pkb-details'].dealer"
                                                class="dealerService"
                                                :options="options['pkb-details'].dealer.map(x => x.dealer)"
                                                placeholder="All Dealer"
                                              ></MultiSelect>
                                            </div>
                                        </div>
                                        <div class="col-md-6 offset-md-6">
                                            <div class="input-group">
                                                <button
                                                    class="btn btn-primary astraColorButton"
                                                    @click="exportFile('PKB Details', 'csv', data['pkb-details'])"
                                                >
                                                    Download CSV <i class="fas fa-download"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <pkb-details
                                v-if="data['pkb-details']"
                                :data="data['pkb-details']"
                            ></pkb-details>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Unit Entry by PKB & PKB Details End -->

        <!-- Unit Entry By Customer Location Start -->
        <div class="outerBox mt-5">
            <div class="row innerBox">
                <div class="col-12">
                    <div class="row">
                        <div class="col-md-6">
                            <h2>Unit Entry By Customer Location <i class="fas fa-info-circle fa-xs ml-3 mt-2" id="unitEntryByCustomerLocation"></i></h2>
                            <b-popover
                                target="unitEntryByCustomerLocation"
                                title="Unit Entry By Customer Location"
                                triggers="hover focus"
                                placement="top"
                                :content="tooltip.unitEntryByCustomerLocation"
                            ></b-popover>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                           <div class="btn-group">
                               <button
                                type="button"
                                class="btn"
                                :class="filter['customer-location'].flag == 'REGION' ? 'astraColorButton' : 'astraColorButtonOutline'"
                                style="width: 150px; height:80%"
                                @click="filter['customer-location'].flag = 'REGION'"
                            >Wilayah Kerja</button>
                            <button
                                type="button"
                                class="btn"
                                :class="filter['customer-location'].flag == 'CITY' ? 'astraColorButton' : 'astraColorButtonOutline'"
                                style="width: 150px; height:80%"
                                @click="filter['customer-location'].flag = 'CITY'"
                            >City</button>
                           </div> 
                        </div>
                        <div class="col-md-6">
                            <div class="row">
                                <div class="col-md-3 offset-md-9">
                                    <div class="input-group">
                                        <button
                                            class="btn btn-primary astraColorButton"
                                            @click="exportFile('Unit Entry By Customer Location', 'csv', data['customer-location'])"
                                        >
                                            Download CSV <i class="fas fa-download"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <unit-entry-by-customer-location
                        v-if="data['customer-location']"
                        :data="data['customer-location']"
                    ></unit-entry-by-customer-location>
                </div>
            </div>
        </div>
        <!-- Unit Entry By Customer Location End -->

        <!-- Unit Entry Body Repair By Insurance Start -->
        <div class="outerBox mt-5">
            <div class="row innerBox">
                <div class="col-12">
                    <div class="row">
                        <div class="col-md-6">
                            <h2>Unit Entry Body Repair By Insurance <i class="fas fa-info-circle fa-xs ml-3 mt-2" id="unitEntryBodyRepairByInsurance"></i></h2>
                            <b-popover
                                target="unitEntryBodyRepairByInsurance"
                                title="Unit Entry Body Repair By Insurance"
                                triggers="hover focus"
                                placement="top"
                                :content="tooltip.unitEntryBodyRepairByInsurance"
                            ></b-popover>
                        </div>
                        <div class="col-md-6">
                            <div class="row">
                                <div class="col-md-3 offset-md-3">
                                    <div class="input-group">
                                        <button
                                            class="btn btn-primary astraColorButton"
                                            @click="exportFile('Unit Entry Body Repair By Insurance', 'csv', data['by-insurance'])"
                                        >
                                            Download CSV <i class="fas fa-download"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="input-group">
                                      <MultiSelect
                                        v-model="filter['by-insurance'].region"
                                        class="dealerService"
                                        :options="options['by-insurance'].region"
                                        placeholder="All Wilayah Kerja"
                                      ></MultiSelect>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="input-group">
                                      <MultiSelect
                                        v-model="filter['by-insurance'].dealer"
                                        class="dealerService"
                                        :options="options['by-insurance'].dealer.map(x => x.dealer)"
                                        placeholder="All Dealer"
                                      ></MultiSelect>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <unit-entry-body-repair-by-insurance
                        v-if="data['by-insurance']"
                        :data="data['by-insurance']"
                    ></unit-entry-body-repair-by-insurance>
                </div>
            </div>
        </div>
        <!-- Unit Entry Body Repair By Insurance End -->

        <!-- Unit Entry By Damage Type Start -->
        <div class="outerBox mt-5">
            <div class="row innerBox">
                <div class="col-12">
                    <div class="row">
                        <div class="col-md-6">
                            <h2>Unit Entry By Damage Type <i class="fas fa-info-circle fa-xs ml-3 mt-2" id="unitEntryByDamageType"></i></h2>
                            <b-popover
                                target="unitEntryByDamageType"
                                title="Unit Entry By Damage Type"
                                triggers="hover focus"
                                placement="top"
                                :content="tooltip.unitEntryByDamageType"
                            ></b-popover>
                        </div>
                        <div class="col-md-6">
                            <div class="row">
                                <div class="col-md-3 offset-md-3">
                                    <div class="input-group">
                                        <button
                                            class="btn btn-primary astraColorButton"
                                            @click="exportFile('Unit Entry By Damage Type', 'csv', data['damage-type'])"
                                        >
                                            Download CSV <i class="fas fa-download"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="input-group">
                                      <MultiSelect
                                        v-model="filter['damage-type'].region"
                                        class="dealerService"
                                        :options="options['damage-type'].region"
                                        placeholder="All Wilayah Kerja"
                                      ></MultiSelect>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="input-group">
                                      <MultiSelect
                                        v-model="filter['damage-type'].dealer"
                                        class="dealerService"
                                        :options="options['damage-type'].dealer.map(x => x.dealer)"
                                        placeholder="All Dealer"
                                      ></MultiSelect>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <unit-entry-by-damage-type
                        v-if="data['damage-type']"
                        :data="data['damage-type']"
                    ></unit-entry-by-damage-type>
                </div>
            </div>
        </div>
        <!-- Unit Entry By Damage Type End -->

        <!-- QR Register & Placement Start -->
        <div class="outerBox mt-5">
            <div class="row innerBox">
                <div class="col-12">
                    <div class="row">
                        <div class="col-md-6">
                            <h2>QR Register & Placement <i class="fas fa-info-circle fa-xs ml-3 mt-2" id="qrRegisterAndPlacement"></i></h2>
                            <b-popover
                                target="qrRegisterAndPlacement"
                                title="QR Register & Placement"
                                triggers="hover focus"
                                placement="top"
                                :content="tooltip.qrRegisterAndPlacement"
                            ></b-popover>
                        </div>
                        <div class="col-md-6">
                            <div class="row">

                                <!-- Week Grouping Start -->
                                <div class="col-md-3 row">
                                    <div class="col-3" style="padding:0">
                                        <button 
                                            style="border-radius : 6px 0px 0px 6px;border: 1px solid #09549F; height: 43px; background-color: #09549F;"
                                            type="button" 
                                            class="w-100 btn btn-primary"
                                            @click="changeWeek('min')"
                                            :disabled="this.week.value <= 1"
                                        >
                                            <i class="fa fa-caret-left" aria-hidden="true" style="color:white"></i>
                                        </button>
                                    </div>
                                    <div class="col-6" style="padding-left:0;padding-right:0">
                                        <p
                                            class="btn w-100 align-middle"
                                            style="border: 1px solid #09549F;border-radius:0px; height: 43px"
                                        >
                                            Week {{week.value}}
                                        </p>
                                    </div>
                                    <div class="col-3" style="padding:0">
                                        <button 
                                            style="border-radius : 0px 6px 6px 0px;border: 1px solid #09549F; height: 43px; background-color: #09549F;"
                                            type="button" 
                                            class="w-100 btn btn-primary"
                                            @click="changeWeek('add')"
                                            :disabled="this.week.value >= week.weekLimit"
                                        >
                                            <i class="fa fa-caret-right" aria-hidden="true" style="color:white"></i>
                                        </button>
                                    </div>
                                    
                                </div>
                                <!-- Week Grouping End -->

                                <div class="col-md-3">
                                    <div class="input-group">
                                        <button
                                            class="btn btn-primary astraColorButton"
                                            @click="exportFile('QR Register & Placement', 'csv', data['qr-register'])"
                                        >
                                            Download CSV <i class="fas fa-download"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="input-group">
                                      <MultiSelect
                                        v-model="filter['qr-register'].region"
                                        class="dealerService"
                                        :options="options['qr-register'].region"
                                        placeholder="All Wilayah Kerja"
                                      ></MultiSelect>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="input-group">
                                      <MultiSelect
                                        v-model="filter['qr-register'].dealer"
                                        class="dealerService"
                                        :options="options['qr-register'].dealer.map(x => x.dealer)"
                                        placeholder="All Dealer"
                                      ></MultiSelect>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <qr-register-and-placement
                        v-if="qrRegisterAndPlacementData"
                        :data="qrRegisterAndPlacementData"
                    ></qr-register-and-placement>
                </div>
            </div>
        </div>
        <!-- QR Register & Placement End -->
        
    </div>
</template>

<script>
    import moment from 'moment'
    import XLSX from 'xlsx'
    import tooltip from '@/Options/tooltips.js'

    import period from './../children/period'

    import unitEntryByPkb from './charts/unitEntryByPkb'
    import pkbDetails from './children/pkbDetailsTable'
    import unitEntryByCustomerLocation from './charts/unitEntryByCustomerLocation'
    import unitEntryBodyRepairByInsurance from './charts/unitEntryBodyRepairByInsurance'
    import unitEntryByDamageType from './charts/unitEntryByDamageType'
    import qrRegisterAndPlacement from './charts/qrRegisterAndPlacement'

    export default {
        data () {
            return {
                tooltip : tooltip.dealerService,
                options : {
                    'pkb-details' : {
                        region : this.$store.getters.getRegion,
                        dealer : this.$store.getters.getDealer
                    },
                    'by-insurance' : {
                        region : this.$store.getters.getRegion,
                        dealer : this.$store.getters.getDealer
                    },
                    'damage-type' : {
                        region : this.$store.getters.getRegion,
                        dealer : this.$store.getters.getDealer
                    },
                    'qr-register' : {
                        region : this.$store.getters.getRegion,
                        dealer : this.$store.getters.getDealer
                    }
                },
                week: {
                    value: 1,
                    weekLimit : 5
                },
            }
        },
        props:['filter', 'data', 'periodFilter'],
        components : {
            period,

            unitEntryByPkb,
            pkbDetails,
            unitEntryByCustomerLocation,
            unitEntryBodyRepairByInsurance,
            unitEntryByDamageType,
            qrRegisterAndPlacement,
        },
        mounted () {

        },
        watch : {
            'periodFilter' : {
                handler () {
                    this.determineNumberOfWeeks(this.periodFilter.start, this.periodFilter.end)
                },
                immediate : true,
            },
        },
        computed : {
            qrRegisterAndPlacementData () {
                if (!this.data['qr-register']) return null
                if (this.week.weekLimit == 1) return this.data['qr-register']

                let data = []

                for (var i = 0; i < 7; i++) {
                    if(this.data['qr-register'][(this.week.value-1) * 7 + i] != null) data.push(this.data['qr-register'][(this.week.value-1) * 7 + i])
                    else break;
                }

                return data;
            },
        },
        methods : {
            newDateRange(obj){
                this.$emit('newDateRange', 'serviceOperation', obj);

                //Reset week
                this.week.value = 1;
                this.determineNumberOfWeeks(obj.start, obj.end);
            },
            exportFile(fileName, type, data){

                let wb = XLSX.utils.book_new()
                var ws = XLSX.utils.json_to_sheet(data, {raw:true});
                XLSX.utils.book_append_sheet(wb, ws, 'Data')

                let exportFileName = `${fileName}.${type}`
                XLSX.writeFile(wb, exportFileName)
            },
            determineNumberOfWeeks (start, end) {
                let diff = moment(end).diff(moment(start), 'days')+1
                this.week.weekLimit = Math.ceil(diff/7);
            },
            changeWeek(flag) {
                if(flag == 'add') this.week.value++
                else this.week.value--
            },
        }
    }
</script>

<style scoped>
    
</style>